import { types, actions } from './requests'
export const CREATEWORK_TYPES = {
    ...types('CREATEWORK'),
}
export const CREATEWORK_ACTIONS = {
    ...actions('CREATEWORK'),
}
